
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34988',
  depVersions: {
  "documents-public-ui": "static-1.34988",
  "atom": "static-1.5257",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2681",
  "client-types": "static-1.489",
  "cssUtils": "static-1.844",
  "customer-data-filters-ui": "static-1.40487",
  "customer-data-objects": "static-1.7862",
  "customer-data-property-utils": "static-1.8279",
  "documents-lib": "static-1.34993",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.353",
  "FormsCommonComponents": "static-1.86332",
  "FormUrlGenerator": "static-2.4904",
  "foundations-theming-specialty": "static-1.2336",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5775",
  "hs-test-utils": "static-1.8205",
  "hub-http": "static-1.6401",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11964",
  "HubStyleTokens": "static-2.11657",
  "I18n": "static-7.1646",
  "icons": "static-2.666",
  "jasmine-immutable": "static-1.3204",
  "jasmine-runner": "static-1.6638",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7334",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5575",
  "quartz": "static-1.7274",
  "react": "static-7.189",
  "react-dlb": "static-1.83",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16885",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5469",
  "react-virtualized": "static-2.102",
  "reference-resolvers": "static-1.8357",
  "reference-resolvers-lite": "static-1.8279",
  "reporting-data": "static-1.68278",
  "reporting-reports": "static-1.67956",
  "reporting-snowflake": "static-1.56896",
  "reporting-testing-lib": "static-1.10211",
  "reporting-visualizations": "static-1.60354",
  "reselect": "static-3.8",
  "sales-content-partitioning": "static-1.9132",
  "sanitize": "static-1.4659",
  "sanitize-text": "static-1.8327",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1926",
  "signup-constants": "static-1.19333",
  "signup-ui-url-generator": "static-2.8241",
  "StyleGuideUI": "static-3.491",
  "superstore": "static-1.4940",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4939",
  "ui-addon-form-validation": "static-1.11171",
  "ui-asset-management-lib": "static-1.11263",
  "ui-images": "static-2.1207",
  "UIComponents": "static-3.8603",
  "usage-tracker": "static-1.7533",
  "usage-tracker-container": "static-1.7523",
  "usage-tracker-core": "static-1.7383",
  "viral-links-lib": "static-1.7254",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9841",
  "foundations-components": "static-1.8284",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1052",
  "quartz-core": "static-1.6493",
  "quick-fetch": "static-1.4046",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4840",
  "ui-addon-i18n": "static-1.11330",
  "ui-addon-upgrades": "static-9.18229",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3529",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3551",
  "quartz-webpack": "static-1.3498",
  "foundations-assets": "static-1.5056",
  "foundations-theming": "static-1.4620",
  "hub-http-shared-msw-handlers": "static-1.10410",
  "hubspotter-http": "static-1.4779",
  "sassPrefix": "static-1.160",
  "conversations-skeleton-state": "static-1.7430",
  "crm-message-bus": "static-1.43500",
  "customer-data-filters-ui-msw-helpers": "static-1.22922",
  "customer-data-objects-ui-components": "static-1.13213",
  "customer-data-reference-ui-components": "static-1.13358",
  "customer-data-ui-utilities": "static-1.10007",
  "events-data-lib": "static-1.419",
  "framework-builder-read-service-client": "static-1.4134",
  "framework-data-schema-quick-fetch": "static-1.6981",
  "framework-data-schema-resolvers": "static-1.7076",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3716",
  "inbound-db-properties-service-client": "static-1.3974",
  "multi-account-reference-resolvers": "static-1.1165",
  "onboarding-tours": "static-1.16943",
  "reporting-datasets-permissions-lib": "static-1.14205",
  "stylex": "static-1.37",
  "trellis-assets": "static-1.2295",
  "trellis-components": "static-1.2314",
  "trellis-theming": "static-1.1130",
  "ui-addon-teams": "static-1.21777",
  "quartz-auth": "static-1.949",
  "ui-business-units-lib": "static-1.9262",
  "usage-tracker-session-replay": "static-1.5219",
  "ai-components-ui-library": "static-1.9419",
  "ContentUtils": "static-1.68902",
  "customer-data-properties": "static-1.52199",
  "forms-ai-lib": "static-1.4598",
  "forms-utils-lib": "static-1.12915",
  "foundations-components-test-utils": "static-1.5767",
  "react-dnd-compat": "static-1.4796",
  "react-tinymce": "static-1.55728",
  "tinymce-config": "static-2.54854",
  "ui-gdpr-components": "static-1.10531",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3605",
  "HeadJS": "static-2.778",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3316",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "hs-locale-management": "static-1.209",
  "ui-fonts": "static-1.919",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4505",
  "csstype": "static-1.50",
  "quartz-head": "static-1.939",
  "web-vitals": "static-1.9",
  "batch-promise": "static-1.1727",
  "external-options-client-types": "static-1.4254",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.949",
  "frontend-preferences-client": "static-1.8109",
  "graphql": "static-1.85",
  "persist-promise": "static-1.3884",
  "reporting-client-types": "static-1.2608",
  "apollo-stack-hubspot": "static-3.89",
  "growth-payments-core": "static-1.25917",
  "hubspot-apollo-client": "static-1.5058",
  "foundations-components-legacy": "static-1.1309",
  "quartz-routing": "static-1.704",
  "hs-story-utils": "static-1.9608",
  "react-flip-move": "static-1.74",
  "nested-table": "static-1.419",
  "timezone-utils": "static-2.5426",
  "seat-types-lib": "static-1.411",
  "react-create-root-preference": "static-1.46",
  "bend-plugin-foundations-components": "static-1.4553",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "tanstack-table": "static-1.58",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.853",
  "mobile-manifest-mixins": "static-1.552",
  "module-federation": "static-1.29",
  "quartz-test": "static-1.949",
  "quartz-tracking": "static-1.653",
  "bend-plugin-chirp-manifest": "static-1.250",
  "chirp-fetch": "static-1.2070",
  "merchandise-lib": "static-1.268",
  "purchase-motions-components": "static-1.6184",
  "salesImages": "static-1.529",
  "ts-schema": "static-1.4208",
  "bender-build-tools": "static-1.3316",
  "bend-plugin-foundations-theming": "static-1.3103",
  "restore-request-side-panel-lib": "static-1.1375",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.360",
  "pulse": "static-1.797",
  "conditional-properties-service-client": "static-1.3925",
  "crm-pipelines-api-client-types": "static-1.4266",
  "fdsr-migration-layer": "static-1.195",
  "multi-currency-client-types": "static-1.3820",
  "getting-started-shared-tasks": "static-1.18950",
  "growth-data-modal": "static-1.5725",
  "growth-onboarding-confetti": "static-1.3244",
  "growth-onboarding-next-action-utils": "static-1.2452",
  "navigation-components": "static-1.18524",
  "onboarding-tours-client": "static-1.5157",
  "onboarding-tours-utils": "static-1.1009",
  "ui-shepherd-react": "static-3.10444",
  "ui-shepherd-tracker": "static-1.7825",
  "ui-universal-auth": "static-1.9193",
  "user-context": "static-1.5293",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.33",
  "hubspotter-http-shared-msw-handlers": "static-1.10408",
  "magpie-lib": "static-1.5676",
  "navigation-messaging": "static-1.7851",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22234",
  "copilot-toolkit": "static-1.11602",
  "cms-field-types": "static-1.4997",
  "content-icons-ui": "static-1.2280",
  "integrations-lib": "static-1.16735",
  "calling-global-api": "static-1.65129",
  "calling-internal-common": "static-1.31494",
  "calling-lifecycle-internal": "static-1.66511",
  "calling-lifecycle-messages": "static-1.58805",
  "commerce-products-lib": "static-1.10238",
  "crm-links": "static-1.6497",
  "customer-data-properties-shared-msw-handlers": "static-1.9737",
  "file-manager-components": "static-1.24161",
  "formula-editor": "static-1.14579",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4345",
  "meetings-icalendar-utils-lib": "static-1.815",
  "object-builder-ui-client": "static-1.49339",
  "pipeline-validation-client-types": "static-1.4095",
  "property-value-citations": "static-1.2813",
  "smart-property-lib": "static-1.8065",
  "tiered-pricing": "static-1.1734",
  "topics-actions-lib": "static-1.332",
  "ui-addon-iframeable": "static-1.9257",
  "zustand": "static-1.79",
  "final-form": "static-1.73",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20145",
  "tinymce-themes": "static-1.56824",
  "data-token-picker": "static-1.16726",
  "hub-http-contrib": "static-1.3225",
  "interframe": "static-3.4938",
  "tinymce-data": "static-1.40939",
  "tinymce-plugins": "static-1.57968",
  "ui-addon-sales-email": "static-1.5395",
  "onboarding-scopes": "static-1.6641",
  "ui-addon-opt": "static-4.8543",
  "apollo-link-hub-http": "static-2.4834",
  "hubspot-apollo-cache": "static-1.517",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.354",
  "purchase-motions-api": "static-1.6187",
  "event-emitter": "static-1.1133",
  "bend-plugin-pulse": "static-1.300",
  "fast-json-patch": "static-1.66",
  "onboarding-data-sync-lib": "static-1.2272",
  "growth-onboarding-next-action-components": "static-1.2480",
  "user-context-client": "static-1.4733",
  "idb-keyval": "static-1.47",
  "magpie-types": "static-1.5136",
  "nest": "static-1.417",
  "reactive-lib": "static-1.906",
  "simple-logging-lib": "static-1.3231",
  "unified-auth-core-lib": "static-1.989",
  "getting-started-shared-tasks-store": "static-1.18068",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1368",
  "integrations-error-boundary-lib": "static-1.14150",
  "integrations-tracking-lib": "static-1.5789",
  "native-integrations-shared-strings": "static-1.7962",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10546",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.707",
  "calling-error-reporting": "static-1.31501",
  "shared-worker-versioning": "static-1.11219",
  "calling-usage-tracker": "static-1.6722",
  "voice-sms-access-library": "static-1.1649",
  "customer-data-tracking": "static-1.7067",
  "commerce-permissions": "static-1.957",
  "products-iframe-lib": "static-1.8371",
  "products-ui-components-shared-msw-handlers": "static-1.10792",
  "location-customization-utils-lib": "static-1.9800",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4330",
  "video-components-external": "static-1.11874",
  "video-data-lib": "static-1.35532",
  "bark-lib": "static-1.16671",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.98",
  "crm-properties-common-lib": "static-1.6069",
  "react-codemirror": "static-1.10816",
  "data-agent-kit": "static-1.482",
  "feedback-loader": "static-1.29634",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10493",
  "fsm": "static-1.3912",
  "policy-lib": "static-1.6968",
  "react-colorpicker": "static-2.10390",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10556",
  "FileManagerLib": "static-1.39801",
  "NamespacedHubStyle": "static-2.9179",
  "FileManagerCore": "static-1.39660",
  "content-assistance-lib": "static-1.8031",
  "layout-dnd-components": "static-1.12794",
  "layout-dnd-utils": "static-1.11769",
  "ui-addon-emoji-picker": "static-1.10066",
  "ui-brand-identity-lib": "static-1.15960",
  "InboxConnectUtils": "static-4.15306",
  "meetings-connect-utils-lib": "static-1.7789",
  "breeze-engine-core": "static-1.646",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "universal-page-editor-lib": "static-1.3194",
  "adobe-sign-auth-lib": "static-1.213",
  "ads-unified-auth-lib": "static-1.703",
  "google-sheets-integration-lib": "static-1.779",
  "microsoft-drive-integration-lib": "static-1.885",
  "surveymonkey-integration-lib": "static-1.228",
  "slack-ui-library": "static-1.10580",
  "calling-orchestration-schema": "static-1.36426",
  "sales-views-client-types": "static-1.4440",
  "crm-record-cards-service-types": "static-1.3713",
  "content-media-composition-data-lib": "static-1.12911",
  "content-media-compositions": "static-2.16918",
  "media-bridge-lib": "static-1.19242",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16104",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4689",
  "storybook-react": "static-1.36",
  "audio-components": "static-1.6186",
  "FileManagerImages": "static-1.37312",
  "video-components": "static-1.13876",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4714",
  "video-embed": "static-1.36366",
  "ui-addon-video-player": "static-1.8889",
  "ui-coaching-tips": "static-1.29070",
  "ContentData": "static-1.68977",
  "layout-data-lib": "static-1.10094",
  "social-insights-client-types": "static-1.22557",
  "outpost": "static-1.4348",
  "growth-onboarding-feedback-components": "static-1.6762",
  "advanced-menus-core": "static-1.15427",
  "advanced-menus-lib": "static-1.12321",
  "ExportDialog": "static-6.10561",
  "ui-memberships-settings-lib": "static-1.34550",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15426",
  "simple-menus-lib": "static-1.16943"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34988",
  "atom": "/atom/static-1.5257",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2681",
  "client-types": "/client-types/static-1.489",
  "cssUtils": "/cssUtils/static-1.844",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40487",
  "customer-data-objects": "/customer-data-objects/static-1.7862",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8279",
  "documents-lib": "/documents-lib/static-1.34993",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.353",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86332",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4904",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2336",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5775",
  "hs-test-utils": "/hs-test-utils/static-1.8205",
  "hub-http": "/hub-http/static-1.6401",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11964",
  "HubStyleTokens": "/HubStyleTokens/static-2.11657",
  "I18n": "/I18n/static-7.1646",
  "icons": "/icons/static-2.666",
  "jasmine-immutable": "/jasmine-immutable/static-1.3204",
  "jasmine-runner": "/jasmine-runner/static-1.6638",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7334",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5575",
  "quartz": "/quartz/static-1.7274",
  "react": "/react/static-7.189",
  "react-dlb": "/react-dlb/static-1.83",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16885",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5469",
  "react-virtualized": "/react-virtualized/static-2.102",
  "reference-resolvers": "/reference-resolvers/static-1.8357",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8279",
  "reporting-data": "/reporting-data/static-1.68278",
  "reporting-reports": "/reporting-reports/static-1.67956",
  "reporting-snowflake": "/reporting-snowflake/static-1.56896",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10211",
  "reporting-visualizations": "/reporting-visualizations/static-1.60354",
  "reselect": "/reselect/static-3.8",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9132",
  "sanitize": "/sanitize/static-1.4659",
  "sanitize-text": "/sanitize-text/static-1.8327",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1926",
  "signup-constants": "/signup-constants/static-1.19333",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8241",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "superstore": "/superstore/static-1.4940",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4939",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11171",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11263",
  "ui-images": "/ui-images/static-2.1207",
  "UIComponents": "/UIComponents/static-3.8603",
  "usage-tracker": "/usage-tracker/static-1.7533",
  "usage-tracker-container": "/usage-tracker-container/static-1.7523",
  "usage-tracker-core": "/usage-tracker-core/static-1.7383",
  "viral-links-lib": "/viral-links-lib/static-1.7254",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9841",
  "foundations-components": "/foundations-components/static-1.8284",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1052",
  "quartz-core": "/quartz-core/static-1.6493",
  "quick-fetch": "/quick-fetch/static-1.4046",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4840",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11330",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18229",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3529",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3551",
  "quartz-webpack": "/quartz-webpack/static-1.3498",
  "foundations-assets": "/foundations-assets/static-1.5056",
  "foundations-theming": "/foundations-theming/static-1.4620",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10410",
  "hubspotter-http": "/hubspotter-http/static-1.4779",
  "sassPrefix": "/sassPrefix/static-1.160",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7430",
  "crm-message-bus": "/crm-message-bus/static-1.43500",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22922",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13213",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13358",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10007",
  "events-data-lib": "/events-data-lib/static-1.419",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4134",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6981",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7076",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3716",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3974",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1165",
  "onboarding-tours": "/onboarding-tours/static-1.16943",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14205",
  "stylex": "/stylex/static-1.37",
  "trellis-assets": "/trellis-assets/static-1.2295",
  "trellis-components": "/trellis-components/static-1.2314",
  "trellis-theming": "/trellis-theming/static-1.1130",
  "ui-addon-teams": "/ui-addon-teams/static-1.21777",
  "quartz-auth": "/quartz-auth/static-1.949",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9262",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5219",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9419",
  "ContentUtils": "/ContentUtils/static-1.68902",
  "customer-data-properties": "/customer-data-properties/static-1.52199",
  "forms-ai-lib": "/forms-ai-lib/static-1.4598",
  "forms-utils-lib": "/forms-utils-lib/static-1.12915",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5767",
  "react-dnd-compat": "/react-dnd-compat/static-1.4796",
  "react-tinymce": "/react-tinymce/static-1.55728",
  "tinymce-config": "/tinymce-config/static-2.54854",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10531",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3605",
  "HeadJS": "/HeadJS/static-2.778",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3316",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "hs-locale-management": "/hs-locale-management/static-1.209",
  "ui-fonts": "/ui-fonts/static-1.919",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4505",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.939",
  "web-vitals": "/web-vitals/static-1.9",
  "batch-promise": "/batch-promise/static-1.1727",
  "external-options-client-types": "/external-options-client-types/static-1.4254",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.949",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8109",
  "graphql": "/graphql/static-1.85",
  "persist-promise": "/persist-promise/static-1.3884",
  "reporting-client-types": "/reporting-client-types/static-1.2608",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "growth-payments-core": "/growth-payments-core/static-1.25917",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5058",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1309",
  "quartz-routing": "/quartz-routing/static-1.704",
  "hs-story-utils": "/hs-story-utils/static-1.9608",
  "react-flip-move": "/react-flip-move/static-1.74",
  "nested-table": "/nested-table/static-1.419",
  "timezone-utils": "/timezone-utils/static-2.5426",
  "seat-types-lib": "/seat-types-lib/static-1.411",
  "react-create-root-preference": "/react-create-root-preference/static-1.46",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4553",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "tanstack-table": "/tanstack-table/static-1.58",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.853",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.552",
  "module-federation": "/module-federation/static-1.29",
  "quartz-test": "/quartz-test/static-1.949",
  "quartz-tracking": "/quartz-tracking/static-1.653",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.250",
  "chirp-fetch": "/chirp-fetch/static-1.2070",
  "merchandise-lib": "/merchandise-lib/static-1.268",
  "purchase-motions-components": "/purchase-motions-components/static-1.6184",
  "salesImages": "/salesImages/static-1.529",
  "ts-schema": "/ts-schema/static-1.4208",
  "bender-build-tools": "/bender-build-tools/static-1.3316",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3103",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1375",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.360",
  "pulse": "/pulse/static-1.797",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3925",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4266",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.195",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3820",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18950",
  "growth-data-modal": "/growth-data-modal/static-1.5725",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3244",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2452",
  "navigation-components": "/navigation-components/static-1.18524",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5157",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1009",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10444",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7825",
  "ui-universal-auth": "/ui-universal-auth/static-1.9193",
  "user-context": "/user-context/static-1.5293",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10408",
  "magpie-lib": "/magpie-lib/static-1.5676",
  "navigation-messaging": "/navigation-messaging/static-1.7851",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22234",
  "copilot-toolkit": "/copilot-toolkit/static-1.11602",
  "cms-field-types": "/cms-field-types/static-1.4997",
  "content-icons-ui": "/content-icons-ui/static-1.2280",
  "integrations-lib": "/integrations-lib/static-1.16735",
  "calling-global-api": "/calling-global-api/static-1.65129",
  "calling-internal-common": "/calling-internal-common/static-1.31494",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66511",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58805",
  "commerce-products-lib": "/commerce-products-lib/static-1.10238",
  "crm-links": "/crm-links/static-1.6497",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9737",
  "file-manager-components": "/file-manager-components/static-1.24161",
  "formula-editor": "/formula-editor/static-1.14579",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4345",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.815",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49339",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4095",
  "property-value-citations": "/property-value-citations/static-1.2813",
  "smart-property-lib": "/smart-property-lib/static-1.8065",
  "tiered-pricing": "/tiered-pricing/static-1.1734",
  "topics-actions-lib": "/topics-actions-lib/static-1.332",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9257",
  "zustand": "/zustand/static-1.79",
  "final-form": "/final-form/static-1.73",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20145",
  "tinymce-themes": "/tinymce-themes/static-1.56824",
  "data-token-picker": "/data-token-picker/static-1.16726",
  "hub-http-contrib": "/hub-http-contrib/static-1.3225",
  "interframe": "/interframe/static-3.4938",
  "tinymce-data": "/tinymce-data/static-1.40939",
  "tinymce-plugins": "/tinymce-plugins/static-1.57968",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5395",
  "onboarding-scopes": "/onboarding-scopes/static-1.6641",
  "ui-addon-opt": "/ui-addon-opt/static-4.8543",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4834",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.517",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.354",
  "purchase-motions-api": "/purchase-motions-api/static-1.6187",
  "event-emitter": "/event-emitter/static-1.1133",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.300",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2272",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2480",
  "user-context-client": "/user-context-client/static-1.4733",
  "idb-keyval": "/idb-keyval/static-1.47",
  "magpie-types": "/magpie-types/static-1.5136",
  "nest": "/nest/static-1.417",
  "reactive-lib": "/reactive-lib/static-1.906",
  "simple-logging-lib": "/simple-logging-lib/static-1.3231",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.989",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18068",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1368",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14150",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5789",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7962",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10546",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.707",
  "calling-error-reporting": "/calling-error-reporting/static-1.31501",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11219",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6722",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1649",
  "customer-data-tracking": "/customer-data-tracking/static-1.7067",
  "commerce-permissions": "/commerce-permissions/static-1.957",
  "products-iframe-lib": "/products-iframe-lib/static-1.8371",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10792",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9800",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4330",
  "video-components-external": "/video-components-external/static-1.11874",
  "video-data-lib": "/video-data-lib/static-1.35532",
  "bark-lib": "/bark-lib/static-1.16671",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.98",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6069",
  "react-codemirror": "/react-codemirror/static-1.10816",
  "data-agent-kit": "/data-agent-kit/static-1.482",
  "feedback-loader": "/feedback-loader/static-1.29634",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10493",
  "fsm": "/fsm/static-1.3912",
  "policy-lib": "/policy-lib/static-1.6968",
  "react-colorpicker": "/react-colorpicker/static-2.10390",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10556",
  "FileManagerLib": "/FileManagerLib/static-1.39801",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9179",
  "FileManagerCore": "/FileManagerCore/static-1.39660",
  "content-assistance-lib": "/content-assistance-lib/static-1.8031",
  "layout-dnd-components": "/layout-dnd-components/static-1.12794",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11769",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10066",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15960",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15306",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7789",
  "breeze-engine-core": "/breeze-engine-core/static-1.646",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3194",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.213",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.703",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.779",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.885",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.228",
  "slack-ui-library": "/slack-ui-library/static-1.10580",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36426",
  "sales-views-client-types": "/sales-views-client-types/static-1.4440",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3713",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12911",
  "content-media-compositions": "/content-media-compositions/static-2.16918",
  "media-bridge-lib": "/media-bridge-lib/static-1.19242",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16104",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4689",
  "storybook-react": "/storybook-react/static-1.36",
  "audio-components": "/audio-components/static-1.6186",
  "FileManagerImages": "/FileManagerImages/static-1.37312",
  "video-components": "/video-components/static-1.13876",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4714",
  "video-embed": "/video-embed/static-1.36366",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8889",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29070",
  "ContentData": "/ContentData/static-1.68977",
  "layout-data-lib": "/layout-data-lib/static-1.10094",
  "social-insights-client-types": "/social-insights-client-types/static-1.22557",
  "outpost": "/outpost/static-1.4348",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6762",
  "advanced-menus-core": "/advanced-menus-core/static-1.15427",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12321",
  "ExportDialog": "/ExportDialog/static-6.10561",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34550",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15426",
  "simple-menus-lib": "/simple-menus-lib/static-1.16943"
}
};
